import { useEffect, useState } from "react";

/**
 * Returns an object URL for the given Blob/File and revokes it on unmount or
 * when the source changes. Prefer this over inline `URL.createObjectURL` calls
 * to avoid leaking object URLs when components re-render or unmount.
 *
 * Returns `null` when `source` is null/undefined.
 */
export function useObjectUrl(
  source: Blob | File | null | undefined,
): null | string {
  const [url, setUrl] = useState<null | string>(null);

  useEffect(() => {
    if (!source) {
      setUrl(null);

      return;
    }

    const next = URL.createObjectURL(source);

    setUrl(next);

    return () => {
      URL.revokeObjectURL(next);
    };
  }, [source]);

  return url;
}
